<template>
  <a-layout-header class="admin-header clearfix">
    <div class="admin-header-left">
      {{ schoolName || "后台管理系统" }}
    </div>
    <div class="admin-header-menuTabs"></div>
    <div class="admin-header-right">
      <!-- <div class="header-right-item">
        <header-notify></header-notify>
      </div> -->
      <div class="header-right-item header-help">
        <a-icon type="home" /><a :href="`/fullScreen?schoolId=${schoolId}`">
          大屏视图
        </a>
      </div>
      <div class="header-right-item">
        <HeaderUser />
      </div>
    </div>
  </a-layout-header>
</template>
<script>
import { Base } from "@/api";
// import MenuInfo from "./Menu.Info.vue";
// import HeaderNotify from "./Header.Notify.vue";
import HeaderUser from "./Header.User.vue";
import { mapGetters, mapState } from "vuex";
export default {
  components: {
    // MenuInfo,
    // HeaderNotify,
    HeaderUser,
  },
  computed: {
    ...mapGetters("setting", ["getCollapsed"]),
    ...mapState("setting", ["collapsed", "isMobile"]),
    ...mapState("user", ["userInfo", "schoolName", "schoolId"]),
  },
  created() {
    this.getAllSysCode();
  },
  data() {
    return {};
  },
  methods: {
    // 是否缩小左菜单
    changCollapsed() {
      this.$store.commit("setting/setCollapsed", !this.getCollapsed);
    },
    // 打开左侧菜单
    showDrawer() {
      this.$emit("drawerBack", true);
    },

    // 获取全部字典列表
    getAllSysCode() {
      Base.sysCodeTypeFindAll().then(res => {
        const newSysCs = {}; // 全部字典数据 值是数组形式
        const newSysCsData = {}; // 全部字典数据  值是键值对对象
        res.data.forEach(element => {
          newSysCs[element.baseTypeCode] = element.details.map(v => ({
            label: v.baseName,
            value: v.baseCode,
          }));
          newSysCsData[element.baseTypeCode] = element.details.reduce(
            (obj, item) => {
              obj[item.baseCode] = item.baseName;
              return obj;
            },
            {}
          );
        });
        console.log(newSysCs);
        console.log(newSysCsData);
        this.$store.commit("setting/setAllSysCode", newSysCs);
        this.$store.commit("setting/setAllSysCodeData", newSysCsData);
      });
    },
    // // 获取公共分类
    // async getCategory() {
    //   const categoryData = await Base.category({});
    //   let newCategory = categoryData.list.filter(item => item.parentId == 0);
    //   newCategory.forEach(element => {
    //     let items = categoryData.list.filter(k => k.parentId == element.id);
    //     if (items.length) {
    //       element.children = items;
    //     }
    //   });
    //   // console.log(newCategory)
    //   this.$store.commit("setting/setCategoryData", newCategory);
    // },
  },
};
</script>
